<template>
  <mk-dialog
    :visible="visible"
    :close-on-click-modal="uploadStatus === 1 ? true : false"
    title="文件上传"
    width="30%"
    @close="onClose"
    @closed="onClosed"
  >
    <div
      v-if="uploadStatus === 0"
      class="uploading"
    >
      <i class="el-icon-loading upload-loading"></i>
      <div class="loading-mention">
        上传中，请耐心等待
      </div>
    </div>
    <div
      v-else
      class="finish"
    >
      <template v-if="errorLength < fileList.length">
        <div class="result-mention">
          <ds-iconfont
            icon-class="icon-ds-chenggongtishi"
            class="upload-ok"
          />
          上传完成
        </div>
        <div class="result-count">
          {{ successLength }}个成功，{{ errorLength }}个失败
        </div>
      </template>
      <template v-else>
        <div class="result-mention">
          <ds-iconfont
            icon-class="icon-ds-cuowutishi"
            class="upload-false"
          />
          上传失败
        </div>
        <div class="result-count">
          0个成功，{{ fileList.length }}个失败
        </div>
      </template>
    </div>
    <div class="upload-list">
      <div
        v-for="(item, index) in fileList"
        :key="index"
        class="file-progress-item"
      >
        <div class="file-name">
          <ds-iconfont icon-class="icon-ds-gongzuotai-fujian" /><span>{{ item.name + '.' + item.suffix }}</span>
        </div>
        <div class="progress">
          <mk-progress
            :percentage="item.progress"
            :color="item.status ? '#67c23a' : '#FF5500'"
          ></mk-progress>
        </div>
      </div>
    </div>
  </mk-dialog>
</template>

<script>
export default {
  name: 'UploadProgress',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    errorLength: {
      type: Number,
      default: 0
    },
    // 上传状态 0 上传中 1 上传结束
    uploadStatus: {
      type: Number,
      default: 0
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => {
        return [{ name: 111, progress: 0.5 }]
      }
    }
  },
  computed: {
    successLength () {
      return this.fileList.length - this.errorLength
    }
  },
  methods: {
    onClose () {
      this.$emit('update:visible', false)
    },
    onClosed () {
      // 上传成功，关闭弹窗，清空fileList
      this.$emit('update:fileList', [])
      this.$emit('update:errorLength', 0)
      this.$emit('update:uploadStatus', 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.uploading {
  text-align: center;

  .upload-loading {
    font-size: 60px;
    color: #009cff;
  }

  .loading-mention {
    margin-top: 20px;
    color: #262626;
    font-size: 13px;
    font-weight: 500;
  }
}

.finish {
  .result-mention {
    color: #262626;
    font-size: 16px;
    font-weight: 500;
  }

  .upload-ok,
  .upload-false {
    font-size: 22px;
    margin-right: 16px;
    color: #52c41a;
  }

  .upload-false {
    color: #f5222d;
  }

  .result-count {
    padding-left: 43px;
    font-size: 13px;
    color: #595959;
    line-height: 24px;
  }
}

.upload-list {
  margin-top: 15px;
  color: #8c8c8c;

  .file-progress-item {
    .file-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon-ds-gongzuotai-fujian {
      margin-right: 8px;
    }

    .progress {
      margin-top: 4px;
      padding: 0 20px;
    }
  }
}
</style>
